<template>
  <div class="topbar-cont">
  <div :class="{'topbar': true, 'is-hidden-mobile': useTopbarHiddenMobile().value}" :style="topbarStyle">
     
    <i class="icon-sidebar sdbr ic" @click.stop="toggleNavbar"></i>

    <TopbarLogo />    
 
    <TopbarSearch 
      :placeholder="$t('main_menu_search_diaries_placeholder')"
      />    
 
      <div class="rmenu">
  
        <NuxtLink v-if="!useAuth().isAuth()" class="lnk icon" to="/diaries/edit/new">                
          <UiButton type="outline">{{ $t('main_menu_start_diary') }}</UiButton>
        </NuxtLink>
          
        <NuxtLink v-if="!useAuth().isAuth()"  class="lnk icon" to="/auth/signin">        
          <i class="icon-lock ic"></i> 
          {{ $t('main_menu_login') }}      
        </NuxtLink>      
        
        <NuxtLink v-if="!useAuth().isAuth()" class="lnk icon" to="/auth/signup">                
          <i class="icon-user-new ic"></i> 
          {{ $t('main_menu_signup') }}
        </NuxtLink>
        
        <NuxtLink 
          v-if="useAuth().isAuth() && useAuth().getAccess('view_extra')" 
          :to="useAuth().getLink() + '/shorts?eed=true'"
          class="lnk lnk-nopadd icon" 
        >
          <UiButton type="link"><i class="icon-shorts"></i> Create Short</UiButton>
        </NuxtLink>
      
        <div class="lnk lnk-nopadd icon diaries" v-if="useAuth().isAuth()" ref="elDiariesPopup" @click="toggleUserPopupDiariesShow()">
          
          <UiButton type="outline"><i class="icon-plus"></i> {{ $t('main_menu_start_diary') }}</UiButton>

          <UserPopupDiaries 
            v-if="showedUserPopupDiaries"   
            :showed="showedUserPopupDiaries" 
            @update:showed="hideUserPopupDiariesShow" 
            />
        </div>
      
        <div :class="'lnk icon notices ' + (userUpdatesLoading ? 'floading' : '')" v-if="useAuth().isAuth()" ref="elNotificationsPopup" @click="toggleUserPopupNoticesShow()">
          <div v-if="userUpdatesNotifications" class="label-new">
            {{ userUpdatesNotifications }}
          </div>
          <i class="icon-alarm ic"></i>      
          <UserPopupNotices 
            v-if="showedUserPopupNotices"   
            :showed="showedUserPopupNotices" 
            @update:showed="hideUserPopupNoticesShow" 
            />
        </div>
  
        <NuxtLink v-if="useAuth().isAuth() && useAuth().getLink()" class="lnk user" :title="useAuth().getName()" :to="useAuth().getLink()">       
          <img loading="lazy" class="avatar" :src="useAuth().getAvatarLittle()">     
          <GeneralLabelUserPremium v-if="useAuth().isPremium()" size="small"/>        
        </NuxtLink>
  
        <div v-if="useAuth().isAuth()" class="lnk icon logout" @click="useAuth().logout({redirect: true})" data-test="home_page_logout_locator">
          <i class="icon-logout ic"></i>
        </div>    

      </div>


 

    <div class="context">
      
      <div id="context" class="ctxb">
        
      </div>


      <div class="def">
        <NuxtLink v-if="useAuth().isAuth() && useAuth().getLink()" class="lnk user" :title="useAuth().getName()" :to="useAuth().getLink()">       
          <img loading="lazy" class="avatar" :src="useAuth().getAvatarLittle()">
          <GeneralLabelUserPremium v-if="useAuth().isPremium()" size="small"/>
        </NuxtLink>  
        <NuxtLink v-else class="lnk user" :title="useAuth().getName()"  to="/auth/signin">       
          {{ $t('main_menu_login') }}           
        </NuxtLink>  
      </div>

    </div>

  </div>

  <div class="empty-space"></div>

  </div>
</template>
 
<script setup lang="ts">
 
import { onClickOutside, useWindowScroll } from '@vueuse/core'

const { $api } = useNuxtApp();

const showedUserPopupDiaries = ref(false)
const showedUserPopupNotices = ref(false)
const navbarOpened = useNavbarOpened();
// single ref for the "navbar-opened" cookie to avoid multiple BroadcastChannels
// const navbarCookie = useCook<boolean>('navbar-opened');
const followCommon = ref(false)
const followBookmark = ref(false)
const activeContext = ref(false)
const timerNotificationsCheck = ref(null)
const countNewNotifications = ref(0)
const status = ref(useAuth().status)
const elDiariesPopup = ref(null)
const elNotificationsPopup = ref(null)
const userUpdatesNotifications = useUserUpdatesNotifications()
const userUpdatesLoading = useUserUpdatesLoading()

const hideUserPopupNoticesShow = function(){   
  if(!showedUserPopupNotices.value) return
  showedUserPopupNotices.value = false;
}

const toggleUserPopupNoticesShow = function(){        
  showedUserPopupNotices.value = !showedUserPopupNotices.value;
}

const toggleUserPopupDiariesShow = function(){        
  showedUserPopupDiaries.value = !showedUserPopupDiaries.value;
}

const hideUserPopupDiariesShow = function(){    
  if(!showedUserPopupDiaries.value) return         
  showedUserPopupDiaries.value = false;
}


const toggleNavbar = async () => {
  navbarOpened.value = !navbarOpened.value;
  // navbarCookie.value = navbarOpened.value; // update cookie via single ref

  if (navbarOpened.value) {
    if (!useFollowCommon().followCommon) {
      await useFollowCommon().load();
      await useFollowBookmark().load();
    }
  }
}

 
if(import.meta.client){
  followCommon.value = useFollowCommon().followCommon
  followBookmark.value = useFollowBookmark().followBookmark
}

// --- progressive hide/show topbar on scroll ------------------------------
const HEIGHT = 52;                   
const { y } = useWindowScroll();     
const lastY = ref(0);
const offset = ref(0);
const triggerStart = ref(60); 

watch(y, (curr) => {
  if (curr < triggerStart.value) {
    offset.value = 0;
    lastY.value = curr;
    return;
  }
  const diff = curr - lastY.value;                    
  offset.value = Math.min(Math.max(offset.value + diff, 0), HEIGHT);
  lastY.value = curr;
});

const topbarStyle = computed(() => ({
  transform: `translateY(-${offset.value}px)`
}));
// -------------------------------------------------------------------------

onClickOutside(elDiariesPopup, (event) => {
  hideUserPopupDiariesShow()
  // event.stopPropagation()
})

onClickOutside(elNotificationsPopup, (event) => {
  hideUserPopupNoticesShow()
  // event.stopPropagation()
})

</script>
  

<style scoped>

.topbar-cont{
  position: relative;
  width: 100%;
}

.topbar{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 101;
  background-color: var(--gd-topbar-back-color);
  height: 52px;
  box-shadow: 0px 0px 20px rgb(0 0 0 / 7%);
  display: flex;
  align-items: center; 
  justify-content: space-between;
  transition: transform .15s ease;
  will-change: transform;
}


.topbar .rmenu{
  margin-left: auto;
  display: flex;
  align-items: center;
    margin-right: 10px;

    flex-shrink: 0;
    margin-left: 1rem;
}

.topbar .sdbr{
  padding: 14px 20px 14px 25px;
  cursor: pointer;
}

.topbar .ic{
  font-size: 1.14rem;
  flex-shrink: 0;
  line-height: 1rem;
}

.label-new{
  position: absolute;
  top: 5px;
  right: 0px;
  background-color: var(--un-firm);
  color: white;
  font-size: 0.5rem;
  padding: 0px 5px;
  border-radius: 15px;
  min-width: 15px;
  font-weight: bold;
  line-height: 1rem;
  margin-right: 5px;
  pointer-events: none;
}

.notices{
  position: relative;
}
.diaries{
  position: relative;
}

.user{
  display: flex;
  align-items: center;
}

.user .avatar{
  border-radius: 40px;
  width: 30px;
  height: 30px;
  margin-right: 5px;
}

.lnk{
  cursor: pointer;
  padding: 15px 13px;
  display: flex;
  align-items: center;
  gap: 10px;
  /* color: var(--gd-navbar-icon-color); */
}

.lnk.icon > i{

}
.lnk.lnk-nopadd{
  padding: 15px 5px;
}
.topbar > .context{
  display: none;
}
.content{
  display: none;
}

@media (max-width: 768px) {
  .content{
    display: flex;
    align-items: center;
    width: 58px;
    justify-content: center;
  }

  .topbar > .context{
    display: block;
  }

  .context .ctxb:has(.ctx) + .def {
    display: none;
  }
  
  .topbar .rmenu{
    display: none;
  }

  .is-hidden-mobile{
    display: none;
  }

}


/* premium */


.lnk.user{
  position: relative;
}
.lnk:deep(.img-premium){
   position: absolute;
   bottom: 14px;
   right: 15px;
}





/* fixed */

.empty-space{
  height: 52px;
}
@media (min-width: 768px) {
  .topbar{
    transform: translateY(0px)!important;
  }
}
@media (max-width: 768px) {
  .empty-space{
    display: block;
    height: 52px;
  }
  .topbar{
    position: absolute;
    top: 0px; 
  }
  .fixed-topbar .topbar{
    position: fixed;
    top: 0px;
  }
  .onnav .topbar{
    position: fixed;
    top: 0px;
    transform: translateY(0px)!important;
  }
}


</style>
